import React from "react";
import CommonFilterStructure from "../common-components/CommonFilterStructure";

const TrainerMemberFilters = ({
  user,
  allFilters,
  setAllFilters,
  onClickReset,
  prevGymId,
  onClickSearch,
  searchFilterApplied,
}) => {
  return (
    <>
      <CommonFilterStructure
        from={"trainer-member"}
        decryptedText={user}
        setFilters={setAllFilters}
        filters={allFilters}
        onClickReset={onClickReset}
        prevGymId={prevGymId}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
      />
    </>
  );
};

export default TrainerMemberFilters;
